module.exports = JSON.parse("{\"timestamp\":\"24.10.2026 - 20:45:15\",\"brands\":[]}")